import {
  tokenKey,
  adjustTokenMap,
  codeKey,
  fromKey,
  taurusAppName,
  master30,
  master130,
  gold30,
  gold130,
  isMakeMoneySEO,
  paramAKey,
  isLoginKey,
  version,
  sChannel,
  homeBackUrl,
  uuIdKey,
  productType,
  isReferralEarnApp
} from '@/constants/index'
import apis from '@/apis'
import { appBack, isInNativeApp, deviceInfoByWeb, openBrowser, deviceInfo } from 'web-utils/device'
import { encrypt } from 'web-utils/encry'
import { downloadFile, queryURLParams } from 'web-utils/url'
import http from '@/apis/request.js'
import { getDownloadUrl } from 'web-biz/urlConfig'
import { getPromptInstall } from './installPrompt'
import { showDialog } from 'vant'
import { isLogin as checkLogin } from 'web-biz/login'
import { deviceInfoReport } from 'web-biz/reportEvent'
import Adjust from '@adjustcom/adjust-web-sdk'
import { getTgUserMsg } from './tg'

export function removeStringTrim(str) {
  return str?.replace(/^\s+|\s+$/g, '')
}
/**
 * 特指有没有手机号登录，非游客登录
 * @returns
 */
export function isLogin() {
  return checkLogin(isLoginKey)
}

export function isGuestLogin() {
  return !!localStorage.getItem(tokenKey)
}

export function clearGuestLogin() {
  localStorage.removeItem(tokenKey)
  localStorage.removeItem(codeKey)
}
export function clearLogin() {
  localStorage.removeItem(isLoginKey)
}

export function dealMobile(mobile) {
  if (!mobile) {
    return ''
  }
  const start = Math.floor(mobile.length / 2) - 3
  return mobile.substr(0, start) + '****' + mobile.substr(start + 6)
}

export function cleanAllServiceWorker() {
  console.log('cleanAllServiceWorker---------------')
  if ('serviceWorker' in navigator) {
    navigator?.serviceWorker?.getRegistrations()?.then((registrations) => {
      for (let registration of registrations) {
        registration.unregister()
      }
      caches.keys().then(function (cacheNames) {
        console.log(cacheNames, '----cacheNames---')
        cacheNames.forEach(function (cacheName) {
          caches.delete(cacheName)
        })
      })
      window.location.reload()
    })
  }
}

export async function cleanIndexServiceWorker() {
  console.log('cleanIndexServiceWorker---------------')
  if ('caches' in window) {
    try {
      // 获取所有缓存名称
      console.log('Before caches.keys()')
      const cacheNames = await caches.keys()
      console.log('All cache names:', cacheNames)
      for (const cacheName of cacheNames) {
        // 检查缓存名称是否包含 'ta_pwa_ca'
        if (cacheName.includes('ta_pwa_ca')) {
          const cache = await caches.open(cacheName)
          console.log(cache, '--cache open--')
          const response = await cache.match('/index.html')
          console.log(response, '--response--')
          if (response) {
            await cache.delete('/index.html')
            console.log('Deleted /index.html from cache:', cacheName)
          }
        }
      }
    } catch (error) {
      console.error('Failed to delete cache:', error)
    }
  }
}

export function adjustTrack(eventId) {
  if (isMakeMoneySEO) return
  const event = adjustTokenMap[eventId]
  if (event) {
    Adjust.trackEvent(event)
  }
}

export function formatRecordCreated(time, preLine) {
  // 年/月/日/
  if (!time) return
  let timeArr = time?.split(' ')
  if (timeArr.length >= 3) {
    let hms = timeArr[1]
    let ymdArr = timeArr[0]?.split('-')
    let year = ymdArr[0]
    let mon = ymdArr[1]
    let day = ymdArr[2]
    let month = getMonthEnglish(mon)
    if (preLine) {
      return `${year} ${month} ${day} \n ${hms}`
    }
    return `${year} ${month} ${day} ${hms}`
  } else {
    return time
  }
}
export function formatWithdrawalTime(time) {
  if (!time) return ''
  // 年/月/日/
  let timeArr = time?.split(' ')
  let hms = timeArr[1]?.split(':')[0] + ':' + timeArr[1]?.split(':')[1]
  let ymdArr = timeArr[0]?.split('-')
  let year = ymdArr[0]
  let mon = ymdArr[1]
  let day = ymdArr[2]
  let month = getMonthEnglish(mon, 'abbreviation')
  return `${month} ${day},${year} ${hms}`
}

export function giftCardCodeencrypt(code) {
  if (!code) return ''
  let codeArr = code.split('-')
  return codeArr[0] + '-******-' + codeArr[codeArr.length - 1]
}

export function maskString(string, showLen) {
  const regex = new RegExp(`^(.{${showLen}})(.*)(.{${showLen}})$`)
  return string.replace(regex, (_, start, middle, end) => {
    const mask = '*'.repeat(middle.length)
    return `${start}${mask}${end}`
  })
}

export function usdtEncrypt(code) {
  if (!code) {
    return ''
  }
  const len = code.length
  if (len === 1) {
    return '*'
  }
  if (len === 2) {
    return `${code[0]}*`
  }
  if (len >= 3 && len <= 7) {
    return maskString(code, 1)
  }
  if (len >= 8 && len <= 12) {
    return maskString(code, 2)
  }
  return maskString(code, 4)
}

const enNumJsonSim = {
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'June',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sept',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec'
}
const enNumJson = {
  '01': 'January',
  '02': 'February',
  '03': 'March',
  '04': 'April',
  '05': 'May',
  '06': 'June',
  '07': 'July',
  '08': 'August',
  '09': 'September',
  10: 'October',
  11: 'November',
  12: 'December'
}

export function getMonthEnglish(monthNum, type) {
  const json = type == 'abbreviation' ? enNumJsonSim : enNumJson
  monthNum = monthNum.toString().padStart(2, '0')
  return json[monthNum]
}

export function getAppType() {
  if (isTGPlatformByBuildType()) {
    return 'tg_mini_app'
  }
  if (isReferralEarnApp) {
    if (isRealTgEnv()) {
      return 'tg_mini_app'
    }
    return 'web_mobile'
  }
  return 'pwa'
}

// 判断是否tg内下载，若为tg内打开，则跳转值空白页打开（已安装）或下载taurus App
export function downloadTaurusJudge() {
  if (isTGPlatform()) {
    window?.Telegram?.WebApp?.openLink(`${homeBackUrl}/ota`)
    return
  }
  downloadTaurusFun()
}

// 下载taurus
export async function downloadTaurusFun(channel = '00003a', isSetCode = true) {
  if (isTGPlatformByBuildType()) {
    channel = '00004a'
  }
  const from = getShareFrom()
  const data = await getDownloadUrl(http, { type: 'APK_PACKAGE_SERVICE', channel })
  if (!data.domain) {
    return
  }
  const code = localStorage.getItem(codeKey) || ''
  let downloadUrl = `${data.domain}/ApkDownload/tasyee?channel=${channel}&downloadType=TAURUS&platform=${getAppType()}${from ? `_${from}` : ''}`
  if (isSetCode) {
    downloadUrl = `${downloadUrl}&sourceCode=${code}`
  }
  downloadUrl = `https://app.adjust.com/1g3sd732?redirect=${encodeURIComponent(downloadUrl)}`
  console.log('downloadTaurusFun', isTGPlatform(), downloadUrl)
  if (isTGPlatform()) {
    window?.Telegram?.WebApp?.openLink(downloadUrl)
  } else {
    downloadFile(downloadUrl)
  }
  adjustTrack('pwa_taurus_apk_download_Click')
  apis.reportPoint('I0110043')
}

export function getShareFrom() {
  // 电召来源特殊处理，以dz开头，统一只提取dz为来源
  let f = localStorage.getItem(fromKey) || queryURLParams('f') || ''
  if (f && f.startsWith('dz')) {
    f = 'dz'
  }
  return f
}

export function getParamA() {
  return localStorage.getItem(paramAKey) || queryURLParams('a') || ''
}

export function back(backUrl) {
  if (isInNativeApp()) {
    appBack()
    return
  }
  if (backUrl) {
    window.location.href = backUrl
  } else {
    window.history.back()
  }
}

export function formatTime(seconds) {
  if (seconds == null || isNaN(seconds)) {
    return ''
  }
  const days = Math.floor(seconds / (3600 * 24))
  const hours = Math.floor((seconds % (3600 * 24)) / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const s = Math.floor(seconds % 60)

  const daysStr = days > 0 ? `${days} days` : ''
  const hoursStr = hours.toString().padStart(2, '0')
  const minutesStr = minutes.toString().padStart(2, '0')
  const secondsStr = s.toString().padStart(2, '0')

  if (days > 0) {
    return `${daysStr} ${hoursStr}:${minutesStr}:${secondsStr}`
  } else if (hours > 0) {
    return `${hoursStr}:${minutesStr}:${secondsStr}`
  }
  return `${minutesStr}:${secondsStr}`
}

export function dealAddDesktopOfCoin(canInstall) {
  const { browser: browserName, deviceType, deviceModel, browserEngine } = deviceInfoByWeb()
  const buriedParams = {
    browserName,
    deviceType,
    deviceModel,
    browserEngine,
    ua: navigator.userAgent
  }
  if (canInstall) {
    console.log('canInstall----2')
    getPromptInstall()(() => {
      apis.reportPoint('I0110018', buriedParams)
      apis.recordPwaUserStatus({ type: 'ADD_TO_DESKTOP' })
    })
  } else {
    showDialog({
      className: 'firebase-unsupport-dialog',
      'confirm-button-text': 'OK',
      message:
        'Adding to desktop failed, please use Chrome browser or update your Chrome browser to the latest version.',
      theme: 'round-button'
    })
    apis.reportPoint('I0110064', buriedParams)
  }
}

// 下载master
export function downloadMaster(activityId = 'pwa', extraParams = {}) {
  const { source, entryType, paramUrl } = extraParams
  const code = localStorage.getItem(codeKey) || ''
  const extObj = {
    code,
    activityId,
    shareFrom: getShareFrom() + (source || ''),
    taurusAppName,
    platform: 'pwa',
    webId: localStorage.getItem(uuIdKey) || ''
  }
  const extParams = queryURLParams('ext')
  if (extParams) {
    const ext = JSON.parse(decodeURIComponent(extParams))
    extObj.ext = ext
  }
  if (entryType) {
    extObj.entryType = entryType
  }
  const ext = encrypt(extObj)
  let url = master30
  if (productType === 'gold130') {
    url = gold130
  } else if (productType === 'master130') {
    url = master130
  }
  const advertiseType = import.meta.env.VITE_AD
  if (advertiseType == 'slm130') {
    url = master130
  } else if (advertiseType == 'slg30' || advertiseType == 'slg30b') {
    url = gold30
  } else if (advertiseType == 'slg130') {
    url = gold130
  }
  url = paramUrl || url
  const downloadUrl = url.replace(/{code}/g, code) + `?ext=${ext}`
  if (isInNativeApp()) {
    openBrowser(downloadUrl)
  } else if (isTGPlatform()) {
    window?.Telegram?.WebApp?.openLink(downloadUrl)
  } else {
    downloadFile(downloadUrl)
  }
}

export async function parseParam() {
  const paramToken = queryURLParams('t')
  if (!paramToken) {
    return ''
  }
  const res = await apis.getParam({ paramToken })
  if (res?.code != 0 || !res?.data.param) {
    return ''
  }
  try {
    const param = JSON.parse(res?.data?.param || '{}')
    const ext = JSON.parse(param.ext || '{}')
    delete param.ext
    return { ...param, ...ext }
  } catch (error) {
    console.log(error)
    return ''
  }
}

export function isGreaterThanHalf() {
  // 生成0-1之间的随机数
  const randomNumber = Math.random()
  return randomNumber > 0.5
}

export function getRandomRange() {
  const randomNumber = Math.random() // 生成0-1之间的随机数
  if (randomNumber >= 0.66) {
    return 2
  }
  if (randomNumber > 0.33) {
    return 1
  }
  return 0
}

export function setCacheWithExpiry(key, value, expiryDays) {
  const now = new Date()
  const expiryDate = new Date(now.getTime() + expiryDays * 24 * 60 * 60 * 1000) // 计算过期时间
  const item = {
    value,
    expiry: expiryDate.getTime() // 保存过期时间戳
  }
  localStorage.setItem(key, JSON.stringify(item))
}

export function getCache(key) {
  const itemStr = localStorage.getItem(key)
  if (!itemStr) {
    return null
  }
  const item = JSON.parse(itemStr)
  const now = new Date()
  if (now.getTime() > item.expiry) {
    // 检查是否过期
    localStorage.removeItem(key) // 过期则删除
    return null
  }

  return item.value
}

export function isTGPlatform() {
  return isTGPlatformByBuildType() && isRealTgEnv()
}

export function isTGPlatformByBuildType() {
  return import.meta.env.VITE_PLATFORM === 'TG'
}
export function isRealTgEnv() {
  // 添加缓存，防止每次去调用
  const key = 'r_tg_env'
  const realTgEnvStr = localStorage.getItem(key)
  if (realTgEnvStr == 1) {
    return true
  }
  const res = !!window?.Telegram?.WebApp?.initDataUnsafe?.user
  if (res) {
    localStorage.setItem(key, 1)
  }
  return res
}
/**
 * 判断build时候type是tg 小程序，但是访问时候不是真正的tg环境，没有tg webview环境
 */
export function isTGPlatformByBuildTypeNotRealTgEnv() {
  return isTGPlatformByBuildType() && !isRealTgEnv() && import.meta.env.MODE != 'dev'
}

export function countPointsDistance(ele1, ele2) {
  const startPoint = ele1?.getBoundingClientRect()
  const endPoint = ele2?.getBoundingClientRect()
  const startPos = {
    x: startPoint.left + startPoint.width / 2,
    y: startPoint.top + startPoint.height / 2
  }
  const endPos = {
    x: endPoint.left + endPoint.width / 2,
    y: endPoint.top + endPoint.height / 2
  }
  return {
    x: endPos?.x - startPos?.x || 0,
    y: endPos?.y - startPos?.y || 0
  }
}
export function isFromFaceBook() {
  const from = queryURLParams('f')
  return from == 'fbbq' || from == 'm130' || from == 'g30' || from == 'g130'
}

export function dealLogin(data) {
  const { user, token } = data || {}
  setCode(user?.code)
  setToken(token)
  if (user?.mobile) {
    setLogin()
  }
}
export function setLogin() {
  localStorage.setItem(isLoginKey, '1')
}
export function setToken(token) {
  if (token) {
    localStorage.setItem(tokenKey, token)
    if (!isInNativeApp()) {
      let webUUId = localStorage.getItem(uuIdKey)
      if (isTGPlatform()) {
        webUUId = getTgUserMsg().id
      }
      deviceInfoReport(http, { webUUId })
    }
  }
}
export function setCode(code) {
  if (code) {
    localStorage.setItem(codeKey, code)
  }
}

// 开发者流量 登录 处理
export async function guestLoginTraffic(loginData = {}, initFun) {
  let f = getShareFrom()
  if (!f || f.indexOf('LUCKYDRAWLITE') === -1) {
    f = 'LUCKYDRAWLITE'
  }
  const data = {
    loginType: 'GUEST',
    appVersion: version,
    shareFrom: f,
    channelSource: sChannel,
    ...loginData
  }
  const res = await apis.login(data)
  if (res?.code !== 0) {
    return
  }
  dealLogin(res?.data)
  initFun()
}

export function jumpByType({ jumpType, link, jumpSource, orderId }) {
  const { appVersion } = deviceInfo()
  if (appVersion >= 220300413) {
    window.TaurusApp?.jumpByType(
      JSON.stringify({
        jumpType,
        link,
        jumpSource,
        params: { orderId }
      })
    )
  }
}

// tg大额提现联系客服
export function contactTgCustomer() {
  const text = `https://t.me/taurusbossK?text=My code is ${localStorage.getItem(codeKey)} Please help me do the withdrawal review faster`

  window?.Telegram?.WebApp?.openTelegramLink(text)
}

// 客户端的分享回调
export function shareSuccess() {
  window.shareSuccess = () => {
    console.log('share success')
  }
}

export function getBuildType() {
  const appType = import.meta.env.VITE_APP_TYPE
  const advertiseType = import.meta.env.VITE_AD
  const tgType = import.meta.env.VITE_TG_TYPE
  if (advertiseType) {
    return `${appType}-${advertiseType}`
  }
  if (tgType) {
    return `${appType}-${tgType}`
  }
}

export function isEmpty(target) {
  if (target === null || target === undefined) return true
  if (typeof target === 'string')
    return target.trim() === '' || target === 'null' || target === 'undefined'
  return false
}

export function defaultIfEmpty(target, defaultValue) {
  return isEmpty(target) ? defaultValue : target
}

// 超过3分钟
export async function checkMoreThanThreeM(cb = null) {
  const startT = sessionStorage.getItem('start_t')
  const params = JSON.parse(sessionStorage.getItem('count_d_params') || '{}')
  if (!startT || !params) {
    return
  }
  const now = Date.now()
  const disT = 3 * 60 * 1000
  console.log('now', now, startT)
  if (now - startT < disT) {
    return
  }
  // 超过3分钟做事件上报
  if (params.onlineReport) {
    await apis.reportOrderEvent(params)
  }
  // 超过三分钟回调
  cb?.()
  sessionStorage.removeItem('start_t')
  sessionStorage.removeItem('count_d_params')
}

// 跳转盲盒
function goCrownBoxPage(uid, params) {
  sessionStorage.setItem('count_d_params', JSON.stringify(params))
  const startT = sessionStorage.getItem('start_t')
  if (!startT) {
    sessionStorage.setItem('start_t', Date.now())
  }
  const crownBoxUrl = `https://ts00.crown11.club?root=${uid}`
  window.open(crownBoxUrl, 'crownbox')
}
// 兜底
function crownFission() {
  window.location.replace('https://gamehosting.info/?channel=00002a&p=p8&f=TSGP')
}

export async function goCrownBox(params) {
  const { jumpLink } = params
  const uid = queryURLParams('uid', jumpLink)
  if (uid && uid != '{uid}' && uid != '%7Buid%7D') {
    goCrownBoxPage(uid, params)
    return
  }
  const channel = queryURLParams('channel', jumpLink)
  if (!channel || channel == '{channel}' || channel == '%7Bchannel%7D') {
    crownFission()
    return
  }
  const code = queryURLParams('code', jumpLink) || localStorage.getItem(codeKey)
  if (!code) {
    crownFission()
    return
  }
  const timeoutPromise = new Promise((_, reject) =>
    setTimeout(() => reject(new Error('timeout')), 10000)
  )
  // 与10s进行比较
  try {
    const res = await Promise.race([apis.crownBoxRegister({ channel }), timeoutPromise])
    if (res?.code == 0 && res.data?.uid) {
      goCrownBoxPage(res.data.uid, params)
    } else {
      crownFission()
    }
  } catch (_) {
    crownFission()
  }
}

export function transformDefaultAvatar(avatar) {
  if (!avatar || !avatar.includes('file:///android_asset/default_avatars')) {
    return avatar
  }
  const avatarMap = new Map()
  const fileUrl = 'file:///android_asset/default_avatars/ic_default_avatar_'
  const httpUrl = 'https://static.taer.xyz/avatar/default-avatar'
  for (let i = 1; i <= 5; i++) {
    avatarMap.set(`${fileUrl}${i}.png`, `${httpUrl}${i}.webp`)
  }
  return avatarMap.get(avatar)
}

/**
 * 高性能前端视频压缩
 * 使用 Canvas + MediaRecorder + 加速录制策略
 *
 * @param {File} file 原始视频文件
 * @param {Object} options 可选项
 * @param {number} [options.maxWidth=720] 最大宽度（自动等比缩放）
 * @param {number} [options.frameRate=15] 输出帧率
 * @param {number} [options.bitrate=1000] 视频比特率 kbps
 * @param {number} [options.playbackRate=2] 压缩播放倍率
 * @param {function(number):void} [options.onProgress] 进度回调(0~100)
 * @returns {Promise<File>} 压缩后的视频文件
 */
export async function compressVideo(
  file,
  { maxWidth = 480, frameRate = 15, bitrate = 1000, playbackRate = 2, onProgress = () => {} } = {}
) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file)
    const video = document.createElement('video')
    video.src = url
    video.muted = true
    video.playsInline = true
    video.crossOrigin = 'anonymous'

    video.onloadedmetadata = () => {
      try {
        // 自动降帧：长视频降低帧率
        const adjustedFrameRate = video.duration > 300 ? Math.max(8, frameRate / 2) : frameRate

        const scale = Math.min(1, maxWidth / video.videoWidth)
        const width = Math.floor(video.videoWidth * scale)
        const height = Math.floor(video.videoHeight * scale)

        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext('2d', { willReadFrequently: true })

        const stream = canvas.captureStream(adjustedFrameRate)
        const chunks = []

        const recorder = new MediaRecorder(stream, {
          mimeType: 'video/webm;codecs=vp8',
          videoBitsPerSecond: bitrate * 1000
        })

        recorder.ondataavailable = (e) => e.data.size && chunks.push(e.data)

        recorder.onstop = () => {
          const blob = new Blob(chunks, { type: 'video/webm' })
          const compressedFile = new File([blob], file.name.replace(/\.[^.]+$/, '.webm'), {
            type: 'video/webm'
          })
          URL.revokeObjectURL(url)
          resolve(compressedFile)
        }

        // 加速播放
        video.playbackRate = playbackRate
        recorder.start(500)

        video.play()

        let lastProgress = 0
        let stopped = false
        let frameCounter = 0

        const drawFrame = () => {
          if (video.paused || video.ended || stopped) return

          frameCounter++
          // 跳帧绘制：每2帧绘制一次
          if (frameCounter % 2 === 0) {
            ctx.drawImage(video, 0, 0, width, height)
          }

          const progress = Math.min((video.currentTime / video.duration) * 100, 100)
          if (progress - lastProgress >= 1) {
            onProgress(Math.round(progress))
            lastProgress = progress
          }

          requestAnimationFrame(drawFrame)
        }

        drawFrame()

        video.onended = () => {
          stopped = true
          onProgress(100)
          recorder.stop()
        }

        video.onerror = () => {
          stopped = true
          recorder.stop()
          URL.revokeObjectURL(url)
          reject(new Error('video load error'))
        }
      } catch (err) {
        URL.revokeObjectURL(url)
        reject(err)
      }
    }
  })
}

// 处理接口Se字段
export function fieldSeHandler(data) {
  // 非对象类型直接返回
  if (data === null || typeof data !== 'object') {
    return data
  }
  // 处理数组
  if (Array.isArray(data)) {
    return data.map((item) => fieldSeHandler(item))
  }
  // 处理对象
  const result = {}
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      const value = data[key]
      let newKey = key
      // 处理Se
      if (key.endsWith('Se')) {
        newKey = key.slice(0, -2)
      }
      // 递归处理对象类型
      result[newKey] = typeof value === 'object' && value !== null ? fieldSeHandler(value) : value
    }
  }
  return result
}

export function getTimeRangeType(timestamp) {
  const now = new Date()
  const target = new Date(timestamp)
  const diffMs = Math.abs(now - target)
  if (diffMs < 60 * 60 * 1000) {
    return 'Last hour'
  }
  const nowYear = now.getFullYear()
  const nowMonth = now.getMonth()
  const nowDate = now.getDate()
  const targetYear = target.getFullYear()
  const targetMonth = target.getMonth()
  const targetDate = target.getDate()
  let type = 'Today'
  if (nowYear === targetYear) {
    if (nowMonth === targetMonth) {
      if (nowDate !== targetDate) {
        const nowDay = now.getDay() || 7 // 周日视为7
        const targetDay = target.getDay() || 7
        const diffDays = Math.abs((now - target) / (1000 * 60 * 60 * 24))
        if (diffDays < 7 && Math.abs(nowDay - targetDay) < 7) {
          type = 'This week'
        } else {
          type = 'This month'
        }
      }
    } else {
      type = 'This year'
    }
  }
  return type
}

export function stripTelegramLink(str) {
  const prefix = 'https://t.me/'
  if (str.startsWith(prefix)) {
    return str.slice(prefix.length)
  }
  return str
}

// 相对时间格式化
export function formatRelativeTime(date) {
  const created = new Date(date)
  const now = new Date()
  const diffMs = now.getTime() - created.getTime()
  const diffHours = Math.floor(diffMs / (1000 * 60 * 60))
  const diffDays = Math.floor(diffHours / 24)

  if (diffDays >= 1) {
    return `${diffDays} days ago`
  }
  if (diffHours >= 1) {
    return `${diffHours} hours ago`
  }
  const diffMinutes = Math.max(1, Math.floor(diffMs / (1000 * 60)))
  return `${diffMinutes} minutes ago`
}

/**
 *
 * 是否具体产品类型的应用
 */
export function isProductTypeApp() {
  const productTypes = ['master', 'bolly', 'master130', 'gold130']
  return productTypes.includes(import.meta.env.VITE_PRODUCT_TYPE)
}

export function moreThanHalf() {
  return Math.random() > 0.5
}

export function downloadFileWithdAdjust(url, adjustToken = '1g7u7mng') {
  if (!url.includes('https://app.adjust.com')) {
    url = `https://app.adjust.com/${adjustToken}?redirect=${encodeURIComponent(url)}`
  }
  downloadFile(url)
}

export function validateEmail(val) {
  return /^[A-Za-z0-9.@]+$/.test(val) && /@/.test(val)
}

export function decodeEntities(html) {
  return html.replace(/&lt;/g, '<').replace(/&gt;/g, '>')
}

export function openLink(url) {
  if (isRealTgEnv()) {
    window?.Telegram?.WebApp?.openLink(url)
    return
  }
  window.location.href = url
}
